import React from 'react';

import dayjs from '~/timeInit';

import { Box, Typography } from '@mui/material';

function OrderFlightLeg({ flights }: { flights: Array<any> }) {
  const formatDate = (date, time) => {
    return dayjs(`${date} ${time}`, 'DDMMYY HHmm').format('DD-MMM-YYYY hh:mmA');
  };

  return (
    <Box className="T-Order-Flight-Item-List">
      {flights.map((flight, idx) => (
        <Box key={idx} sx={{ mb: 2 }} className="order-item">
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                p: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
              }}
            >
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6">{flight.departureLocation}</Typography>
                <Typography variant="body2">{formatDate(flight.departureDate, flight.departureTime)}</Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6">{'====================>'}</Typography>
                <Typography variant="body2">{flight.aircraftNumber}</Typography>
              </Box>
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="h6">{flight.arrivalLocation}</Typography>
                <Typography variant="body2">{formatDate(flight.arrivalDate, flight.arrivalTime)}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default OrderFlightLeg;
